<template>
	<v-row>
		<v-col cols="12">
			<v-card class="pa-3 elevation-0 rounded-lg">
				<v-row>
					<v-col cols="12">
						<v-form ref="formBank" role="form">
							<v-row v-if="Object.values(data).length > 0">
								<v-col cols="12" sm="6" class="px-5 pb-5">
									<v-row>
										<v-col cols="12" sm="12" class="px-5 pb-0">
											<v-text-field label="Nama Rekening" color="primary" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="bank_account_name" tabindex="1" :disabled="!isEditing" :rules="rules.input"></v-text-field>
										</v-col>
										<v-col cols="12" sm="12" class="px-5 pb-0">
											<v-text-field label="Nomor Rekening" color="primary" class="input-regis" prepend-inner-icon="mdi-circle-multiple" hide-details="auto" v-model="bank_account_no" tabindex="2" :disabled="!isEditing" :rules="rules.input"></v-text-field>
										</v-col>
									</v-row>
								</v-col>

								<v-col cols="12" sm="6" class="px-5 pb-5">
									<v-row>
										<v-col cols="12" sm="12" class="px-5 pb-0">
											<v-autocomplete label="Nama Bank" no-data-text="Tidak ada data" color="primary" class="input-regis" prepend-inner-icon="mdi-bank" hide-details="auto" v-model="data_bank"  tabindex="3" :disabled="!isEditing" :items="list" item-text="bank_name" item-value="bank_id" :rules="rules.input" return-object></v-autocomplete>
										</v-col>
										<v-col cols="12" sm="12" class="px-5 pb-0">
											<v-text-field label="Kota" color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker" hide-details="auto" v-model="bank_city" tabindex="4" :disabled="!isEditing" :rules="rules.input"></v-text-field>
										</v-col>
										<v-col cols="12" sm="12" class="px-5">
											<v-text-field label="Cabang" color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker-plus" hide-details="auto" v-model="bank_branch" tabindex="5" :disabled="!isEditing" :rules="rules.input"></v-text-field>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-form>
					</v-col>
				</v-row>
			</v-card>
			<v-row class="pt-5" v-if="data.member_bank_id == 0">
				<v-col cols="6" sm="3" md="3" v-if="!isEditing">
					<v-btn large depressed block class="bg-primary white--text rounded-lg" @click="isEditing = !isEditing">
						<v-icon>mdi-pencil</v-icon>
						<span class="pl-2">Ubah</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing">
					<v-btn large depressed block class="bg-primary white--text rounded-lg" @click="save" :loading="btnLoadingProses" :disabled="btnLoadingProses">
						<v-icon>mdi-content-save-outline</v-icon>
						<span class="pl-2">Simpan</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing">
					<v-btn large depressed block class="rounded-lg grey--text text--darken-2" color="grey lighten-2" @click="isEditing = !isEditing" :loading="btnLoadingProses" :disabled="btnLoadingProses">
						<v-icon>mdi-close</v-icon>
						<span class="pl-2">Batal</span>
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			isActiveMember: false,
			btnLoadingProses: false,
			isEditing: null,
			data_bank: '',
			bank_id: '',
			bank_name: '',
			bank_city: '',
			bank_branch: '',
			bank_account_name: '',
			bank_account_no: '',
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong',
				],
			},
		}
	},
	props: {
		list: { type: Array },
		data: { type: Object },
	},
	computed: {
		
	},
	methods: {
		...mapActions('profile', ['editBankMitra', 'editBankPramitra']),

		setDataBank(){
			this.data_bank = this.data.member_bank_id
			this.bank_id = this.data.member_bank_id
			this.bank_name = this.data.member_bank_name
			this.bank_city = this.data.member_bank_city
			this.bank_branch = this.data.member_bank_branch
			this.bank_account_name = this.data.member_bank_account_name
			this.bank_account_no = this.data.member_bank_account_no
		},
		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},
		async save() {
			if (this.$refs.formBank.validate()) {
				let params = {
					bank_id: this.data_bank.bank_id,
					bank_name: this.data_bank.bank_name,
					bank_city: this.bank_city,
					bank_branch: this.bank_branch,
					bank_account_name: this.bank_account_name,
					bank_account_no: this.bank_account_no,
				}

				if (this.isActiveMember) {
					await this.editBankMitra(params)
				} else {
					await this.editBankPramitra(params)
				}
				this.btnLoadingProses = await false
				this.isEditing = await !this.isEditing
			}
		},
	},
	async created() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.checkMemberActivation(data)
		this.setDataBank()
	},
};
</script>